class DragCarousel extends HTMLElement {
  #isDown = false;
  #startX = 0;
  #startScrollLeft = 0;
  #isDragging = false;

  connectedCallback() {
    this.addEventListener('pointerdown', this.#onPointerDown);
    this.addEventListener('pointermove', this.#onPointerMove);
    this.addEventListener('pointerup', this.#onPointerUp);
    this.addEventListener('pointercancel', this.#onPointerUp);
    this.addEventListener('click', this.#onClickCapture, true);
  }

  disconnectedCallback() {
    this.removeEventListener('pointerdown', this.#onPointerDown);
    this.removeEventListener('pointermove', this.#onPointerMove);
    this.removeEventListener('pointerup', this.#onPointerUp);
    this.removeEventListener('pointercancel', this.#onPointerUp);
    this.removeEventListener('click', this.#onClickCapture, true);
  }

  #onPointerDown = (e) => {
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    this.#isDown = true;
    this.#isDragging = false;
    this.#startX = e.clientX;
    this.#startScrollLeft = this.scrollLeft;
    this.setPointerCapture(e.pointerId);
    this.style.cursor = 'grabbing';
    this.style.userSelect = 'none';
  };

  #onPointerMove = (e) => {
    if (!this.#isDown) return;
    const walk = e.clientX - this.#startX;
    if (Math.abs(walk) > 5) this.#isDragging = true;
    this.scrollLeft = this.#startScrollLeft - walk;
  };

  #onPointerUp = () => {
    if (!this.#isDown) return;
    this.#isDown = false;
    this.style.cursor = '';
    this.style.userSelect = '';
    setTimeout(() => {
      this.#isDragging = false;
    }, 0);
  };

  #onClickCapture = (e) => {
    if (this.#isDragging) {
      e.preventDefault();
      e.stopPropagation();
    }
  };
}

class CartSuggestedProducts extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#handleClick);
  }

  #handleClick = async (e) => {
    const btn = e.target.closest('.cart-suggested-products__add-btn');
    if (!btn) return;

    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    const cartItemsComponent = document.querySelector('cart-items-component[data-section-id]');
    const sectionId = cartItemsComponent?.dataset.sectionId;

    const btnText = btn.querySelector('.cart-suggested-products__add-btn-text');
    btn.disabled = true;
    if (btnText) btnText.textContent = '...';

    try {
      const body = { id: parseInt(variantId, 10), quantity: 1 };
      if (sectionId) body.sections = sectionId;

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });

      const data = await response.json();

      if (response.ok) {
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: data,
              sourceId: this.id || 'cart-suggested-products',
              data: {
                sections: data.sections || {},
                variantId,
                itemCount: data.item_count,
              },
            },
          })
        );

        if (btnText) btnText.textContent = 'ADDED';
        setTimeout(() => {
          if (btnText) btnText.textContent = 'ADD';
          btn.disabled = false;
        }, 2000);
      } else {
        if (btnText) btnText.textContent = 'ADD';
        btn.disabled = false;
      }
    } catch {
      if (btnText) btnText.textContent = 'ADD';
      btn.disabled = false;
    }
  };
}

if (!customElements.get('drag-carousel')) {
  customElements.define('drag-carousel', DragCarousel);
}
if (!customElements.get('cart-suggested-products')) {
  customElements.define('cart-suggested-products', CartSuggestedProducts);
}
